/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItem_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItemsGrid_viewer$ref: FragmentReference;
export type PdpRespSimilarItemsGrid_viewer = {|
  +$fragmentRefs: PdpRespSimilarItem_viewer$ref,
  +$refType: PdpRespSimilarItemsGrid_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGrid_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '19f988926e2b264c883ba4e84213252d';
module.exports = node;
